import {Component, OnInit, ViewChild} from '@angular/core';
import {SnotifyService} from 'ng-snotify';
import {TGrnService} from './service/t-grn.service';
import {TGrn} from './model/t-grn';
import {TGrnItem} from './model/t-grn-item';
import {AppSettings} from '../../settings/app-settings';
import {MSupplierService} from '../../master-files/m-supplier/service/m-supplier.service';
import {MItemService} from '../../service/m-item/service/m-item.service';
import {MItem} from '../../service/m-item/model/m-item';
import {MSupplier} from '../../master-files/m-supplier/model/m-supplier';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {Observable} from '../../../../../node_modules/rxjs';
import {TStockLedgerService} from '../../service/t-stock-ledger/service/t-stock-ledger.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-t-grn',
  templateUrl: './t-grn.component.html'
})
export class TGrnComponent implements OnInit {

  private tGrn: TGrn;
  private tGrnItem: TGrnItem;
  private mItems: MItem [] = [];
  private mSuppliers: MSupplier [] = [];
  private uiMode: string;

  @ViewChild('inputFormTGrn') inputFormTGrn;
  @ViewChild('inputFormGrnItem') inputFormGrnItem;

  constructor(private snotifyService: SnotifyService,
              private spinner: NgxSpinnerService,
              private tGrnService: TGrnService,
              private mSupplierService: MSupplierService,
              private mItemService: MItemService,
              private tStockLedgerService: TStockLedgerService) {
    this.tGrn = new TGrn();
    this.tGrnItem = new TGrnItem();
  }

  ngOnInit() {
    this.spinner.show();
    this.uiMode = 'IDEAL';
    this.loadMSuppliers();
    // this.loadMItems();
    this.tGrn = new TGrn();
    this.tGrnItem = new TGrnItem();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

  findByTransactionNumber(): void {
    if (typeof this.tGrn.transactionNumber !== undefined) {
      if (!this.tGrn.transactionNumber) {
        this.snotifyService.error('Please Enter Trasaction Number', 'ERROR', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
        this.tGrn = new TGrn();
      } else {
        this.tGrnService.findByTransactionNumber(this.tGrn.transactionNumber).subscribe((data) => {
            this.uiMode = 'SELECTED';
            this.tGrn = data;
            this.tGrn.transactionDate = new Date(this.tGrn.transactionDate).toISOString().slice(0, 16);
            this.getTotal();
          },
          (e) => {
            this.snotifyService.error(e.error.message, 'ERROR', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            });
            this.tGrn = new TGrn();
          });
      }
    }
  }

  itemFindByBarcode() {
    if (this.tGrnItem.itemBarcode) {
      console.log(this.tGrnItem.itemBarcode);
      this.mItemService.findByBarcode(this.tGrnItem.itemBarcode).subscribe((data) => {
        this.tGrnItem.item = data;
        this.tGrnItem.price = this.tGrnItem.item.price;
        this.tStockLedgerService.getStockQtyByItemBarcodeAndBranch(this.tGrnItem.itemBarcode).subscribe((data) => {
          this.tGrnItem.stock = data;
        }, (e) => {
          this.tGrnItem.stock = 0;
        });
      }, (e) => {
        this.snotifyService.warning('Item Not Found!', AppSettings.MESSAGE_ERROR, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
        this.tGrnItem.item = new MItem();
      });
    }

  }

  getCommisionValue(): void {
    this.tGrnItem.discountValue = 0;
    if (this.tGrnItem.value > 0) {
      if (this.tGrnItem.discount) {
        this.tGrnItem.discountValue = (this.tGrnItem.value * this.tGrnItem.discount) / 100;
        this.tGrnItem.netValue = this.tGrnItem.value - this.tGrnItem.discountValue;
      }
    }
  }

  getCommisionPrcentage(): void {
    this.tGrnItem.discount = 0;
    if (this.tGrnItem.value > 0) {
      if (this.tGrnItem.discountValue) {
        this.tGrnItem.discount = (this.tGrnItem.discountValue * 100) / this.tGrnItem.value;
        this.tGrnItem.netValue = this.tGrnItem.value - this.tGrnItem.discountValue;
      }
    }
  }

  getValue(): void {
    this.tGrnItem.value = this.tGrnItem.price * this.tGrnItem.qty;
    this.tGrnItem.netValue = this.tGrnItem.value - this.tGrnItem.discountValue;
    this.tGrn.totalFinalAmount = this.tGrn.totalNetAmount + this.tGrn.nbtValue + this.tGrn.vatValue;
  }

  newFormData(): void {
    this.tGrn.transactionNumber = null;
    this.uiMode = 'EDIT';
    this.tGrn.transactionDate = new Date().toISOString().slice(0, 16);
  }

  sumbmitFormData(): void {
    if (!this.tGrn.supplier) {
      this.snotifyService.warning('Select Supplier', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (this.tGrn.tGrnItemList.length === 0) {
      this.snotifyService.warning('Select Items', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (!this.tGrn.transactionType) {
      this.snotifyService.warning('Select Trasaction Type', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              console.log(this.tGrn);
              this.tGrnService.save(this.tGrn).subscribe((tGrn) => {
                this.snotifyService.success('Grn Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  clearFormData(): void {
    this.uiMode = 'IDEAL';
    this.loadMSuppliers();
    // this.loadMItems();
    this.tGrn = new TGrn();
    this.tGrnItem = new TGrnItem();
  }

  // formatterMItem = (x: { barcode: string }) => x.barcode;
  // searchMItem = (text$: Observable<string>) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     map(term => term === '' ? []
  //       : this.mItems.filter(v => v.barcode.toString().toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  //   );

  formatterMSupplier = (x: { name: string }) => x.name;
  searchMSupplier = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mSuppliers.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  loadMSuppliers(): void {
    this.mSupplierService.findAll().subscribe((data) => {
      this.mSuppliers = data;
    }, (e) => {
      this.mSuppliers = [];
    });
  }

  // loadMItems(): void {
  //   this.spinner.show();
  //   this.mItemService.findAll().subscribe((data) => {
  //     this.mItems = data;
  //     if (this.mItems.length > 50000) {
  //       this.spinner.hide();
  //     }
  //   }, (e) => {
  //     this.mItems = [];
  //   });
  // }

  addGrnItem(): void {
    if (!this.tGrnItem.item) {
      this.snotifyService.warning('Select Item Barcode', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (!this.tGrnItem.qty) {
      this.snotifyService.warning('Select Item Qty', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else if (this.tGrnItem.item && this.tGrnItem.qty) {
      if (this.inputFormGrnItem.invalid) {
        this.snotifyService.warning('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true
        });
      } else {
        this.tGrn.tGrnItemList.unshift(this.tGrnItem);
        this.tGrnItem = new TGrnItem();
      }
    }
    this.getTotal();
  }

  editGrnItem(rowNo, tGrnItem: TGrnItem): void {
    this.tGrnItem = tGrnItem;
    this.tGrn.tGrnItemList.splice(rowNo, 1);
  }

  deleteGrnItem(rowNo: number) {
    this.tGrn.tGrnItemList.splice(rowNo, 1);
    this.getTotal();
  }

  getTotal(): void {
    var totalNetAmount: number = 0;
    var totalDiscountValue: number = 0;
    var totalItemQty: number = 0;
    var totalPrice: number = 0;
    for (var tGrn of this.tGrn.tGrnItemList) {
      totalNetAmount += tGrn.netValue;
      totalDiscountValue += tGrn.discountValue;
      totalItemQty += parseFloat(tGrn.qty.toString());
      totalPrice += tGrn.price;
    }

    this.tGrn.totalNetAmount = totalNetAmount;
    this.tGrn.totalDiscountValue = totalDiscountValue;
    this.tGrn.totalItemQty = totalItemQty;
    this.tGrn.totalPrice = totalPrice;
    this.tGrn.totalFinalAmount = this.tGrn.totalNetAmount + this.tGrn.nbtValue + this.tGrn.vatValue;
  }

  getNBTValue(): void {
    if (this.tGrn.totalNetAmount > 0) {
      if (this.tGrn.nbt > 0) {
        this.tGrn.nbtValue = (this.tGrn.totalNetAmount * this.tGrn.nbt) / 100;
        this.tGrn.totalFinalAmount = this.tGrn.totalNetAmount + this.tGrn.nbtValue + this.tGrn.vatValue;
      } else {
        this.tGrn.nbtValue = 0;
      }
      this.getVATValue();
    }
  }

  getVATValue(): void {
    if (this.tGrn.totalNetAmount > 0) {
      if (this.tGrn.vat > 0) {
        this.tGrn.vatValue = (this.tGrn.totalNetAmount + this.tGrn.nbtValue) * this.tGrn.vat / 100;
        this.tGrn.totalFinalAmount = this.tGrn.totalNetAmount + this.tGrn.nbtValue + this.tGrn.vatValue;
      } else {
        this.tGrn.vatValue = 0;
      }
    }
    this.getNBTValue();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-grn/t-grn.component.ts